export default __webpack_public_path__ + "tab1_video_poster53575d.png";